import { RevxDiscTextItem } from 'components/RevxDiscTextItem';
import { ConfigSvcProps } from '..';

const CommonJobSvcMessage = (props: ConfigSvcProps) => {
  const { jobOptionSvc } = props;
  return (
    <>
      {Boolean(jobOptionSvc?.message) && (
        <div
          className="jobconfig-jobOption-content-disc"
          style={{ marginLeft: 7 }}
        >
          <RevxDiscTextItem>
            <div>
              <p>{jobOptionSvc.message.replaceAll('*', '')}</p>
            </div>
            {/* <Trans i18nKey="jobConfig.jobOption.tip"></Trans> */}
          </RevxDiscTextItem>
        </div>
      )}
    </>
  );
};

export default CommonJobSvcMessage;
